//region :: Imports ::
import {evalulateBool, MBoolean} from './Control';
import MComponent from '../Component';
import {Dropdown, DropdownChangeParams} from 'primereact/dropdown';
import {ReactElement} from 'react';
import MDropDownOption, {MDropDownItem} from './DropDownOption';
import MDropDownSelection from './DropDownSelection';
import {MNullable, setFieldValue} from '../../Utils';
import {FieldProps} from 'formik';

//endregion

/** */
type Props<TValue> = {
    id: string;
    initialValue?: MNullable<TValue>;
    items: MDropDownItem<TValue>[];
    placeholderText?: string;
    showFilter?: boolean;
    isBusy?: MBoolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: MNullable<TValue>) => void;
}

/** */
type State<TValue> = {
    value: MNullable<TValue>;
}

/** */
class MDropDown<TValue> extends MComponent<Props<TValue>, State<TValue>> {

    /** */
    public constructor(props: Props<TValue>) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.getSelectionTemplate = this.getSelectionTemplate.bind(this);
        this.dropDown_OnChange = this.dropDown_OnChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? null : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private dropDown_OnChange(params: DropdownChangeParams): void {
        this.setValue(params.value);
    }

    /** */
    public static getOptionTemplate<TValue>(item: MDropDownItem<TValue>): ReactElement<MDropDownOption<TValue>> {

        return (
            <MDropDownOption label={item.label}
                             value={item.value}
                             badge={item.badge}
                             badgeSeverity={item.badgeSeverity}/>
        );

    }

    /** */
    public getSelectionTemplate<TValue>(selectedItem: MNullable<MDropDownItem<TValue>>): ReactElement<MDropDownSelection> {

        return (
            <MDropDownSelection text={selectedItem === null ? this.props.placeholderText : selectedItem.label}
                                isBusy={evalulateBool(this.props.isBusy)}/>
        );

    }

    /** */
    public setValue(newValue: TValue): void {

        this.safeSetState((draft: State<TValue>) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props<TValue>>, prevState: Readonly<State<TValue>>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State<TValue>) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <Dropdown id={this.props.id}
                      optionLabel="label"
                      optionValue="value"
                      options={this.props.items}
                      filter={this.props.showFilter}
                      placeholder={this.props.placeholderText}
                      valueTemplate={this.getSelectionTemplate}
                      itemTemplate={MDropDown.getOptionTemplate}
                      disabled={evalulateBool(this.props.disabled)}
                      className={this.props.className}
                      {
                          ...this.props.fieldProps?.field
                      }
                      value={this.state.value}
                      onChange={this.dropDown_OnChange}/>
        );

    }

}

export default MDropDown;
